import axios from "axios";

const api = axios.create({
  baseURL: "https://apicolaborador.cozimax.com.br/",
  //baseURL: "http://10.0.2.152:3205",
  auth :{username:'@@cozimax2026',password:'@@cozimax2026'}
});

export default api;